import { RootState } from "store";

export const getTableFilters = (state: RootState) => state.tableFilters;
